
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token/[mint]",
      function () {
        return require("private-next-pages/token/[mint].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token/[mint]"])
      });
    }
  